import type { NormalizedCacheObject } from '@apollo/client'
import { ApolloClient, ApolloLink } from '@apollo/client'
import type { ErrorResponse } from '@apollo/client/link/error'
import { onError } from '@apollo/client/link/error'
import { SchemaLink } from '@apollo/client/link/schema'

import { getSchema } from '@acre/graphql/schema'
import { authRedirectErrorLink, graphqlErrorLink, lutherErrorLink } from '@acre/utils'

import cache from './cache'

const initApollo = () => {
  const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
    connectToDevTools: process.env.NODE_ENV !== 'test',
    link: ApolloLink.from([
      onError(graphqlErrorLink),
      onError(lutherErrorLink),
      onError((error: ErrorResponse) => authRedirectErrorLink(error, client)),
      new SchemaLink({
        schema: getSchema(),
        context: (operation) => operation.getContext(),
      }),
    ]),
    cache,
  })

  return client
}

export default initApollo

let loaderClient: ApolloClient<NormalizedCacheObject> | undefined

// For route loaders, which query outside React. Built on first use so importing this module
// doesn't build the client and schema.
export const getClient = () => (loaderClient ??= initApollo())
